import { ContainerAttributesDto, ContainerDto } from '@planning/app/api'
import { containerService } from '@planning/services'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'

export class AddUnitInfoFormWrapperStore {
  isLoading = false
  isBoxtechLoading = false
  containerAttributes: ContainerAttributesDto | undefined
  existingContainers: ContainerDto[] = []
  boxtechError = false
  hasFetchedContainer = false

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      isBoxtechLoading: observable,
      containerAttributes: observable,
      existingContainers: observable,
      boxtechError: observable,
      hasFetchedContainer: observable,

      hasExistingContainers: computed,

      setLoading: action,
      setBoxtechLoading: action,
      setContainerAttributes: action,
      setBoxtechError: action,
      reset: action,
      fetchContainerAttributes: action,
      fetchExistingContainers: action,
      setHasFetchedContainer: action,
    })
  }

  get hasExistingContainers() {
    return this.existingContainers.length > 0
  }

  setHasFetchedContainer(value: boolean) {
    this.hasFetchedContainer = value
  }

  setLoading = (loading: boolean) => {
    this.isLoading = loading
  }

  setBoxtechLoading = (loading: boolean) => {
    this.isBoxtechLoading = loading
  }

  setContainerAttributes = (data: ContainerAttributesDto | undefined) => {
    this.containerAttributes = data
  }

  setBoxtechError = (hasError: boolean) => {
    this.boxtechError = hasError
  }

  reset = () => {
    this.containerAttributes = undefined
    this.existingContainers = []
    this.boxtechError = false
    this.hasFetchedContainer = false
  }

  fetchContainerAttributes = async (containerNumber: string) => {
    this.setLoading(true)
    try {
      const result = await containerService.getAttributes(containerNumber)
      runInAction(() => {
        this.setContainerAttributes(result)
        this.setBoxtechError(false)
      })
    } catch (e) {
      runInAction(() => this.setBoxtechError(true))
    } finally {
      this.setLoading(false)
    }
  }

  fetchExistingContainers = async (containerNumber: string) => {
    const response = await containerService.getContainersByPartialNumber(containerNumber)
    runInAction(() => {
      this.existingContainers = response.filter(c => c.number === containerNumber)
    })
  }
}
